import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard React examples
// import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";
import Logo from './../../../../assets/images/logo.png'

// Authentication layout components
// import Footer from "layouts/authentication/components/Footer";

function BasicLayout({ title, description, image, logoComponent, children }) {
  return (
    <PageLayout>
      <SoftBox>
        <Grid container spacing={1} justifyContent="center" alignItems="center" sx={{ minHeight: "100vh", maxHeight: "100%" }}>
          <Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
            <Card style={{padding: '50px 50px 60px'}}>
              <Grid container spacing={3} justifyContent="center" sx={{ textAlign: "center" }}>
                <Grid item lg={12}>
                    <SoftBox display="flex" justifyContent="center" mb={logoComponent ? 1 : 0}>
                      {logoComponent ?? (
                        <img src={Logo} alt="Logo" style={{ width: "120px" }} />
                      )}
                    </SoftBox>
                    <SoftBox mt={0} mb={0}>
                      <SoftTypography variant="h2" color="black" fontWeight="bold">
                        {title}
                      </SoftTypography>
                    </SoftBox>
                    <SoftBox mb={2}>
                      <SoftTypography variant="body2" color="black" fontWeight="regular" style={{fontSize: '14px'}}>
                        {description}
                      </SoftTypography>
                    </SoftBox>
                </Grid>
              </Grid>
              {children}
            </Card>
          </Grid>
        </Grid>
      </SoftBox>
    </PageLayout>
  );
}

// Setting default values for the props of BasicLayout
BasicLayout.defaultProps = {
  title: "",
  description: "",
  logoComponent: null,
  image: "",
};

// Typechecking props for the BasicLayout
BasicLayout.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  logoComponent: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export default BasicLayout;
